<template>
  <v-text-field
  v-model="inputVal"
    type="number"
    label='Quantity'
    key="name"
    :rules="rules"
  ></v-text-field>
</template>

<script>
export default {
   props: ["value"],
    data: () => ({
    name: null,
     rules : [v => !!v || 'Quantity is required'],
   
  }),
   computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style>
</style>